import { useEffect, useRef, useState, useDropzone, toast } from '../../common/common';
import useNavigation from '../../common/useNavigation';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import axiosJWT from '../../secureAPI/axiosJWT';
import useGetUserData from '../../secureAPI/GetUserData';
import { validateAddProductDetailsForm } from '../../validation/Authentication/Validation';
import { validateAddProductVariantForm } from '../../validation/Authentication/Validation';
import { useErrorContext } from '../../context/ErrorContext';
import { v4 as uuidv4 } from 'uuid';
import { Removehyphen } from '../../common/CommonFunctions';
const MidAddProducts = (type) => {

    const { navigateDashboard, handlenavigateProducts } = useNavigation();
    const { setValidationError, clearAllErrors } = useErrorContext();
    const { users, userPlan, Remainuser, subUser } = useGetUserData();
    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(false);

    const [uniqueID, setUniqueID] = useState('');
    useEffect(() => {
        showToast('', '');
        if (Array.isArray(users) && users.length > 0) {
            logUserData();
            getunique_key();
        }
    }, [users]);
    const logUserData = () => {
        if (users?.length > 0) {
            const userTypes = users[0]['UserType'];
            const usertypeArray = typeof userTypes === 'string' ?
                userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];

            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);
            if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) {
            }
            else {
                navigateDashboard('buyer');
            }
        }
    };

    const [disabledStatus, setDisabledStatus] = useState({
        productDetails: true,
        productCategories: true,
        productVariant: true,
        productPhoto: true,
        productDocument: true,
        productOffers: true,
        productShortDescription: true,
        productLongDescription: true,
    })

    const getunique_key = () => {
        const ciphertext = uuidv4();
        const start = Date.now();
        var temp_unique_id = Removehyphen(ciphertext);
        var unique_id = temp_unique_id + start;
        setUniqueID(unique_id);
    }
    const [values, setValues] = useState(
        {
            productName: '',
            productCode: '',
            productTax: '',
            shortdescription: '',
        }
    );
    // const [isProductdetails, setisProductdetails] = useState(false);
    const [categories, setCategories] = useState([]); // Store all categories
    const [selectedCategories, setSelectedCategories] = useState([]); // Store selected categories dynamically
    const [options, setOptions] = useState([]); // Store the options for each category
    const [categoryData, setCategoryData] = useState({}); // Store dynamic data for each select box


    const [variationmodalShow, setVariationmodalshow] = useState(false);
    const [userAttributesarray, setUserAttributesArray] = useState([]);
    const [packingtype, setPackingtype] = useState(false);
    const [packingtypeSelected, setPackingtypeSelected] = useState('');
    const [measurementinputValue, setMeasurementInputValue] = useState('');
    const [packingtypedata, setPackingtypeData] = useState([]);
    const [measurementdata, setmeasurementData] = useState([]);
    const [packingtypeinputValue, setPackingtypeInputValue] = useState('');

    const [shippingpackingtype, setShippingPackingtype] = useState(false);
    const [shippingpackingtypeSelected, setShippingPackingtypeSelected] = useState('');
    const [shippingpackingtypeinputValue, setShippingPackingtypeInputValue] = useState('');
    const [shippingpackingtypedata, setShippingPackingtypeData] = useState([]);
    const [shippingmeasurementinputValue, setShippingMeasurementInputValue] = useState('');

    const [Selected, setSelected] = useState('');
    const [shippingSelected, setShippingSelected] = useState('');

    const [variantCount, setvariantCount] = useState(0);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [getVariant, setgetVariant] = useState([]);

    const [badges, setBadges] = useState([]);
    const [warehouse, setWarehouse] = useState([]);
    // product Photos 
    const [filePreviews, setFilePreviews] = useState([]); // Store file previews (URLs)
    // const [uploadedImages, setUploadedImages] = useState([]); // Store uploaded image paths
    const [uploadingStatus, setUploadingStatus] = useState(""); // To show uploading status
    const [photoerror, setPhotoError] = useState(""); // To store errors
    const [isUploading, setIsUploading] = useState(false); // To control the upload button


    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        accept: 'image/*', // Allow only images
        multiple: true,
        maxFiles: 10,  // Limit to 10 files
        onDrop: (files) => {
            setPhotoError(''); // Reset photo error

            // Ensure no previous files are set
            const invalidFiles = files.filter(file => !file.type || file.type === "" || !file.type.startsWith('image/'));

            if (invalidFiles.length > 0) {
                setPhotoError('Only image files are allowed');
                return;  // Exit if invalid files are found
            }

            const previews = files.map((file) => ({
                file,
                preview: URL.createObjectURL(file), // Create a preview URL for each image
            }));

            setFilePreviews((prev) => [...prev, ...previews]);
        },
    });

    // Clear previous state when page reloads
    useEffect(() => {
        showToast('', '');
        setFilePreviews([]);
        setPhotoError('');
    }, []);



    // const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    //     accept: 'image/*',
    //     multiple: true,
    //     maxFiles: 10,  // Limit to 10 files
    //     onDrop: (files) => {
    //         setPhotoError('');
    //         const previews = files.map((file) => ({
    //             file,
    //             preview: URL.createObjectURL(file), // Create a preview URL for each image
    //         }));
    //         setFilePreviews((prev) => [...prev, ...previews]);
    //     },
    // });

    const [fileTitle, setFileTitle] = useState('');
    const [currentFile, setCurrentFile] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const fileInputRef = useRef(null);


    // Product Offers 

    const [offermodalshow, setOffermodalshow] = useState(false);
    const [offerdata, setOfferData] = useState([{ offers: "" }]);
    const [offers, setOffers] = useState([]);
    // PRoduct Short Description
    const [shortdesc, setShortDescription] = useState('');
    const [longdesc, setLongDescription] = useState('');

    const [selectedBadge, setSelectedBadge] = useState();
    const [selectedwarehouse, setSelectedwarehouse] = useState();

    const [isVariantVisible, setIsVariantVisible] = useState(false);
    const [isVariantActive, setIsVariantActive] = useState(false);


    useEffect(() => {
        showToast('', '');
        getCategories(0);
        getProductsBadges();
        getProductswarehouse();
    }, []);


    const handleBadgeChange = (selectedOption) => {
        // console.log({ selectedOption: selectedOption });
        setSelectedBadge(selectedOption);
        // console.log('Selected Badge:', selectedOption);
    };
    const handlewarehouseChange = (selectedOption) => {
        setSelectedwarehouse(selectedOption);
        // console.log('Selected warehouse:', selectedOption);
    };
    const getProductsBadges = async () => {
        StartLoading(setisLoading);
        try {
            const res = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/GetProductBadges`,
                { app: 0 },
                { withCredentials: true }
            );

            StopLoading(setisLoading);

            if (res.data.success === 1) {
                setBadges(res.data.data);
            }
            // else {
            //     showToast(res.data.message, 'error');
            // }
        } catch (err) {
            StopLoading(setisLoading);

            if (err.response && err.response.data && err.response.data.message) {
                // API se jo message aaya he use show karo
                // showToast(err.response.data.message, 'error');
            } else {
                // agar koi aur error ho (jaise network error)
                showToast('Something went wrong! Please try later', 'error');
            }
        }
    };


    // const getProductsBadges = async () => {
    //     StartLoading(setisLoading);
    //     try {
    //         await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProductBadges`, { app: 0 }, { withCredentials: true })
    //             .then((res) => {
    //                 StopLoading(setisLoading);
    //                 if (res.data.success === 1) {
    //                     setBadges(res.data.data);
    //                 }
    //                 else {
    //                     StopLoading(setisLoading)
    //                     showToast(res.data.message, 'error');
    //                 }
    //             })
    //             .catch((err) => {
    //                 StopLoading(setisLoading)
    //                 showToast('Something went wrong 1 ! please try again ', 'error');
    //             });
    //     }.catch((err) => {
    //     StopLoading(setisLoading);

    //     if (err.response && err.response.data && err.response.data.message) {
    //         // API se jo message aaya he use show karo
    //         // showToast(err.response.data.message, 'error');
    //     } else {
    //         // agar kuch aur error ho (jaise network error)
    //         showToast('Something went wrong! Please try later', 'error');
    //     }
    // });
    // }


    const getProductswarehouse = async () => {
        StartLoading(setisLoading);
        try {
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/Getwarehouse`,
                { app: 0 },
                { withCredentials: true }
            );

            StopLoading(setisLoading);

            if (response.data?.success === 1) {
                setWarehouse(response.data.data);
            } else {
                // showToast(response.data?.message || 'Operation failed', 'error');
            }
        } catch (err) {
            StopLoading(setisLoading);

            // Handle different error cases
            if (err.response) {
                // The request was made and the server responded with a status code
                // showToast(err.response.data?.message || 'Server responded with an error', 'error');
            } else if (err.request) {
                // The request was made but no response was received
                // showToast('No response received from server', 'error');
            } else {
                // Something happened in setting up the request
                // showToast('Request setup error: ' + err.message, 'error');
            }

            // console.error('Error details:', err);
        }
    };
    //   Short Description 
    const handleshortdescChange = (e, editor) => {
        const shortDescriptiondata = editor.getData();
        setShortDescription(shortDescriptiondata);
    }







    useEffect(() => {
        showToast('', '');
        if (disabledStatus.productVariant) {
            getUserAttributes();
            getPackingType();
            getPackingMeasurement();
        }
    }, [disabledStatus.productVariant]);

    const getPackingMeasurement = async () => {
        StartLoading(setisLoading);
        await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getmeasurementlist`, { app: 0 }, { withCredentials: true })
            .then((res) => {
                if (res.data.success === 1) {
                    StopLoading(setisLoading)
                    showToast(res.data.message, 'success');
                    const transformedData = res.data.data.map(Measurement => ({
                        label: Measurement.measurement_name,
                        value: Measurement.id,
                    }));
                    // console.log({ transformedData: transformedData });
                    setmeasurementData(transformedData);
                    // setPackingtypeData(res.data.data);
                }
                else if (res.data.success === 0) {
                    StopLoading(setisLoading)
                    // showToast(res.data.message, 'error');
                }
            })
            .catch((err) => {
                StopLoading(setisLoading);

                if (err.response && err.response.data && err.response.data.message) {
                    // API se jo message aaya he use show karo
                    // showToast(err.response.data.message, 'error');
                } else {
                    // agar kuch aur error ho (jaise network error)
                    showToast('Something went wrong! Please try later', 'error');
                }
            });
    };

    const getPackingType = async () => {
        StartLoading(setisLoading);
        await axiosJWT.post(
            `${process.env.REACT_APP_API_URL}/api/GetPackingtypes`,
            { app: 0 },
            { withCredentials: true }
        )
            .then((res) => {
                if (res.data.success === 1) {
                    StopLoading(setisLoading);
                    showToast(res.data.message, 'success');
                    const transformedData = res.data.data.map(Packingtype => ({
                        label: Packingtype.type_name,
                        value: Packingtype.id,
                    }));
                    setPackingtypeData(transformedData);
                } else if (res.data.success === 0) {
                    StopLoading(setisLoading);
                    // showToast(res.data.message, 'error');
                }
            })
            .catch((err) => {
                StopLoading(setisLoading);

                if (err.response && err.response.data && err.response.data.message) {
                    // API se jo message aaya he use show karo
                    // showToast(err.response.data.message, 'error');
                } else {
                    // agar kuch aur error ho (jaise network error)
                    showToast('Something went wrong! Please try later', 'error');
                }
            });
    };

    const stringtoarray = (return_array) => {
        setUserAttributesArray(return_array.split(','));
    }
    const getUserAttributes = () => {
        axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetUserProductAttributes`, { app: 0 }, { withCredentials: true })
            .then((res) => {
                if (res.data.success === 1) {
                    const return_array = res.data.selectedArray[0]['selected_attributes_id'];
                    stringtoarray(return_array);
                }
                else if (res.data.success === 0) {
                    //   toast.error(res.data.message, {
                    //     position: "top-center",
                    //     autoClose: 2000,
                    //     hideProgressBar: true,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     progress: undefined,
                    //     theme: "colored",
                    //   });
                }
            })
            .catch((err) => { })
    }
    const getCategories = async (categoryID) => {
        // console.log(categoryID);
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetCategories`, { categoryID, app: 0 }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    // console.log(response.data);
                    if (response.data.success === 1) {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'success');
                        const formattedCategories = response.data.data.map(category => ({
                            value: category.id,
                            label: category.name,
                            status:category.status
                        }));
                        setCategories(formattedCategories);

                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast(" later 1 ", 'error');
        }
    };




    const handleCategoryChange = async (index, selectedOption) => {
        // Copy the current selected categories
        const newSelectedCategories = [...selectedCategories];
        // console.log({ newSelectedCategories: newSelectedCategories });

        // Update the selected option for the current index
        newSelectedCategories[index] = selectedOption ? selectedOption.value : null;

        // Remove any categories after the current index (reset subsequent indices)
        for (let i = index + 1; i < newSelectedCategories.length; i++) {
            newSelectedCategories[i] = null;
        }

        // Filter out `null` values from the selected categories
        const filteredCategories = newSelectedCategories.filter(value => value !== null);

        // Set the filtered selected categories
        setSelectedCategories(filteredCategories);

        // Fetch sub-categories or next level options for the selected category
        if (selectedOption) {
            const categoryID = selectedOption.value;
            try {
                // Replace with your API for fetching next-level categories or sub-categories
                const response = await axiosJWT.post(
                    `${process.env.REACT_APP_API_URL}/api/GetCategories`,
                    { categoryID },
                    { withCredentials: true }
                );
                // console.log(response.data);

                // Check if the API response is successful and contains valid data
                if (response.data.success === 1 && Array.isArray(response.data.data) && response.data.data.length > 0) {
                    // Format the options if the response has subcategories
                    const formattedOptions = response.data.data.map(subCategory => ({
                        value: subCategory.id,
                        label: subCategory.name,
                        status:subCategory.status
                    }));

                    // Update category data to show subcategory select
                    setCategoryData(prevData => ({
                        ...prevData,
                        [index + 1]: formattedOptions // Dynamically add options for next select
                    }));
                } else {
                    // If no subcategories are found, show alert and do not add a new select
                    // showToast("No more categories found", 'error');

                    // Optionally clear the next select options if no subcategories
                    setCategoryData(prevData => ({ ...prevData, [index + 1]: [] }));
                }
            } catch (error) {
                console.error('Error fetching sub-categories:', error);
            }
        } else {
            // Clear options if no category is selected
            setCategoryData(prevData => ({
                ...prevData,
                [index + 1]: []
            }));
        }
    };


    const handleDetailsInputChange = e => {

        const { name, value } = e.target;
        setValues(prevValues => ({ ...prevValues, [name]: value }));

        // console.log({ values: values });
        if (Object.keys(validateAndSetErrors(values)).length === 0) clearAllErrors();
    };

    const validateAndSetErrors = (values) => {
        const validationErrors = validateAddProductDetailsForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };

    const validateAndSetErrorsVariants = (values) => {
        const validationErrors = validateAddProductVariantForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };

    const handleProductDetailsSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateAndSetErrors(values);
        StartLoading(setisLoading);
        // console.log({ validationErrors: validationErrors });
        if (Object.keys(validationErrors).length === 0) {
            StopLoading(setisLoading)
            clearAllErrors();
            ProductDetailsSubmit();
        }
        else {
            showToast("Required Field Missing !!!", 'error');
        }
        StopLoading(setisLoading)

    }



    const ProductDetailsSubmit = async () => {
        const product_name = values.productName;
        const product_code = values.productCode;
        const product_tax = values.productTax;
        const shortdescription = values.shortdescription;

        const ProductdBadgeID = selectedBadge?.value || 0;
        const productWarehouseID = selectedwarehouse?.value || 0;
        const product_unique_id = uniqueID;

        if (
            product_name !== '' &&
            product_code !== '' &&
            shortdescription !== '' &&
            product_tax !== '' &&
            product_unique_id !== ''
        ) {
            StartLoading(setisLoading);

            try {
                const res = await axiosJWT.post(
                    `${process.env.REACT_APP_API_URL}/api/AddproductDetails`,
                    {
                        product_name,
                        product_code,
                        ProductdBadgeID,
                        productWarehouseID,
                        product_tax,
                        product_unique_id,
                        shortdescription,
                        app: 0,
                    },
                    { withCredentials: true }
                );

                // console.log("API success response:", res);

                if (res.status === 201 && res.data.success === 1) {
                    showToast(res.data.message, 'success');
                    setDisabledStatus(prev => ({
                        ...prev,
                        productDetails: false,
                        productCategories: false,
                    }));
                } else {
                    // console.log('Unexpected success response:', res);
                    showToast(res.data?.message || 'Unexpected response.', 'error');
                }
            } catch (err) {
                StopLoading(setisLoading);
                // console.error("Caught error from API call:", err);
                if (err.response) {
                    const status = err.response.status;
                    const message = err.response.data?.message || 'Server error occurred.';
                    // console.log("Error response:", err.response);

                    if (status === 409) {
                        showToast(message || 'Product already exists.', 'error');
                    } else if (status === 400) {
                        showToast("Missing required fields.", 'error');
                    } else {
                        showToast(message, 'error');
                    }
                } else if (err.request) {
                    showToast('No response from server. Please try again later.', 'error');
                } else {
                    showToast(err.message || 'Unexpected error occurred.', 'error');
                }
            }
        } else {
            StopLoading(setisLoading);
            showToast("Please fill all required fields", 'error');
        }
    };

    const handleProductCategrySubmit = async (e) => {

        e.preventDefault();
        clearAllErrors();
        ProductCategoriesSubmit();
    }
    const ProductCategoriesSubmit = async () => {


        const product_ID = selectedCategories;
        const product_unique_id = uniqueID;

        if (product_ID !== '' && product_unique_id !== '') {
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddproductCategory`, { product_ID, product_unique_id, app: 0 }, { withCredentials: true })
                    .then((response) => {
                        StopLoading(setisLoading);
                        if (response.data.success === 1) {
                            showToast(response.data.message, 'success');
                            setDisabledStatus(prevState => ({ ...prevState, productDetails: false, productCategories: false, productVariant: false, }));
                            // setisProductdetails(true);
                            // setisVariantbtndisabled(false);
                            // setisPricedisabled(true);
                            // setisProductofferdisabled(true);
                            // setisVariantData(true);
                        }
                        else {
                            StopLoading(setisLoading)
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        if (err.status === 401) {
                            // alert('Logout');
                        }
                        else {
                            showToast(err.data.message, 'error');
                        }
                    });
            } catch (err) {
                StopLoading(setisLoading);
                const errorMessage = err?.response?.data?.message || "Something went wrong!";
                showToast(errorMessage, 'error');
            }

        }
        else {
            StopLoading(setisLoading);
            showToast("Please Fill All Required Fileds ", 'error');
        }


    }

    // product Variant

    const [variants, setVariants] = useState([])
    const [variantvalues, setVariantValue] = useState(
        {
            sellingUnit: "",
            measurement: 0,
            shippingmeasurement: 0,
            sellingUnitPackingType: "",
            ShippingUnit: "",
            shippingUnitPackingType: "",
            productVariant: "",
            productHSN: "",
            productWarenty: "",
            productOU: "",
            productMOQ: "",
            productID: "",
            productMRP: "",
            productPrice: "",
            Link: "",
            Stock: "",
            fileImage: "",
            visible: 0,
            active: 0,
        }
    );
    useEffect(() => {
        showToast('', '');
        if (variantCount !== 0) {
            const timer = setTimeout(() => {
                GetproductVariants();
            }, 1000); // 2000 milliseconds = 2 seconds

            return () => clearTimeout(timer); // Cleanup on unmount
        }
    }, [variantCount]);
    const handlevariationmodalshow = () => {
        setVariationmodalshow(true);
        setVariantValue(prevValues => ({
            ...prevValues,
            visible: 0,
            active: 0,
        }));
    }
    const handlevariationmodalhide = () => {
        setVariationmodalshow(false);
    }
    const handleSellingUnit = e => {
        var p = new RegExp(/^[0-9\b]+$/);
        const { name, value } = e.target;
        if (value === '' || p.test(value) || e.which !== 69) {
            setVariantValue({ ...variantvalues, [name]: value });
        }
    };


    const handleVariantInput = e => {
        const { name, value } = e.target;
        setVariantValue({ ...variantvalues, [name]: value });
    };

    const handlepackingtype = (result) => {
        // alert(result.value);
        setVariantValue(prevValues => ({
            ...prevValues,
            measurement: result.value,
        }));
    };

    const handleshippingpackingtype = (result) => {
        // alert(result.value);
        setVariantValue(prevValues => ({
            ...prevValues,
            shippingmeasurement: result.value,
        }));
    };

    // console.log(variantvalues);
    const handleVariantPhotoUpload = e => {
        // console.log(e.target.files[0]);
        setVariantValue({ ...variantvalues, productPhoto: e.target.files[0] });
    };

    // const handlevariantSave = async (e) => {

    //     e.preventDefault();
    //     StartLoading(setisLoading);
    //     // const validationErrors = validateAndSetErrorsVariants(values);
    //     // console.log({ validationErrors: validationErrors });
    //     // if (Object.keys(validationErrors).length === 0) {
    //     //     StopLoading(setisLoading)
    //     //     clearAllErrors();

    //     setVariants([...variants, variantvalues]);
    //     setVariantValue({
    //         sellingUnit: "",
    //         sellingUnitPackingType: "",
    //         shippingUnit: "",
    //         shippingUnitPackingType: "",
    //         productVariant: "",
    //         productHSN: "",
    //         productWarenty: "",
    //         productMOQ: "",
    //         productPhoto: null, // Reset photo field
    //     });
    //     handlevariationmodalhide();


    //     const { productSize, sellingUnit, sellingUnitPackingType, measurement, shippingmeasurement, ShippingUnit, shippingUnitPackingType, productVariant, productHSN, productWarenty, productMOQ, productID, productMRP, productPrice, Link, stock, productPhoto, visible, active } = variantvalues;

    //     const formData = new FormData();
    //     formData.append('ProductUniqueID', uniqueID);
    //     formData.append('ProductSize', productSize);
    //     formData.append('Measurement', measurement);
    //     formData.append('shippingmeasurement', shippingmeasurement);
    //     formData.append('sellingUnit', sellingUnit);
    //     formData.append('sellingUnitPackingType', sellingUnitPackingType);
    //     formData.append('ShippingUnit', ShippingUnit);
    //     formData.append('shippingUnitPackingType', shippingUnitPackingType);
    //     formData.append('ProductVariant', productVariant);
    //     formData.append('ProductHSN', productHSN);
    //     formData.append('ProductWarranty', productWarenty);
    //     formData.append('ProductMOQ', productMOQ);
    //     formData.append('ProductID', productID);
    //     formData.append('productMRP', productMRP);
    //     formData.append('ProductPrice', productPrice);
    //     formData.append('Link', Link);
    //     formData.append('Visible', visible);
    //     formData.append('Active', active);
    //     formData.append('ProductImage', productPhoto);
    //     try {
    //         await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddProductVariant`, formData, { withCredentials: true })
    //             .then((res) => {
    //                 StopLoading(setisLoading);
    //                 console.log(res.data.data);
    //                 // console.log(res.data.data.length);
    //                 // setvariantCount(res.data.data.length);
    //                 // handlevariationmodalhide();
    //                 // setDisabledStatus(prevState => ({
    //                 //     ...prevState, productDetails: false, productVariant: false, productPhoto: false,
    //                 // }));


    //             }).catch((err) => {
    //                 if (err.response) {
    //                     console.error('Server responded with a status:', err.response.status);
    //                     console.error('Response data:', err.response.data);
    //                 } else if (err.request) {
    //                     console.error('No response received:', err.request);
    //                 } else {
    //                     console.error('Error setting up request:', err.message);
    //                 }
    //                 // toastifn(0, "Something went wrong! Please try again later.");
    //             });
    //     } catch (err) {
    //         StopLoading(setisLoading);
    //         showToast("Failed to , please try again later ", 'error');
    //     }
    //     // }
    // };

    const [variantError , setVariantError]=useState({})

    const handlevariantSave = async (e) => {
        e.preventDefault();
        
        const validationErrors = validateAddProductVariantForm(variantvalues);
        
        if (Object.keys(validationErrors).length > 0) {
            setVariantError(validationErrors);
            return;
        }

        StartLoading(setisLoading);

        try {
            const {

                sellingUnit,
                sellingUnitPackingType,
                measurement,
                shippingmeasurement,
                ShippingUnit,
                shippingUnitPackingType,
                productVariant,
                productHSN,
                productWarenty,
                productMOQ,
                productID,
                productMRP,
                productPrice,
                Link,
                // stock,
                productPhoto,
            } = variantvalues;


            // Create FormData and append all fields
            const formData = new FormData();
            formData.append('ProductUniqueID', uniqueID);
            formData.append('sellingUnit', sellingUnit);
            formData.append('sellingUnitPackingType', sellingUnitPackingType);
            formData.append('Measurement', measurement);

            formData.append('ShippingUnit', ShippingUnit);
            formData.append('shippingUnitPackingType', shippingUnitPackingType);
            formData.append('shippingmeasurement', shippingmeasurement);

            formData.append('ProductVariant', productVariant);
            formData.append('ProductID', productID);

            formData.append('ProductHSN', productHSN);
            formData.append('ProductWarranty', productWarenty);
            formData.append('ProductMOQ', productMOQ);
            formData.append('productMRP', productMRP);
            formData.append('ProductPrice', productPrice);

            formData.append('Link', Link || ''); // Handle possible undefined
            formData.append('Visible', isVariantVisible);
            formData.append('Active', isVariantActive);
            formData.append('app', 0);

            // Only append file if it exists
            if (productPhoto) {
                formData.append('ProductImage', productPhoto);
            }

            // Make the API call with proper headers
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/AddProductVariant`,
                formData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    // Add timeout to prevent hanging
                    timeout: 60000, // 30 seconds
                }
            );
            // Handle successful response
            StopLoading(setisLoading);
            //   console.log('Response data:', response.data);
            if (!response || !response.data) {
                throw new Error('Invalid server response structure');
            }

            if (response.data && response.data.success === 1) {

                // Update state only after confirmed success
                // setVariantValue({
                //     sellingUnit: "",
                //     sellingUnitPackingType: "",
                //     shippingUnit: "",
                //     shippingUnitPackingType: "",
                //     productVariant: "",
                //     productHSN: "",
                //     productWarenty: "",
                //     productMOQ: "",
                //     productPhoto: null,
                // });
                setVariants([...variants, variantvalues]);
                handlevariationmodalhide();
                setDisabledStatus(prevState => ({
                    ...prevState, productPhoto: false,
                }));
            } else {
                throw new Error(response.data?.message || 'Unknown server response');
            }


        } catch (error) {
            StopLoading(setisLoading);

            // Enhanced error handling
            let errorMessage = 'Failed to add variant';

            if (error.response) {
                // Server responded with error status (4xx, 5xx)
                console.error('Server error:', error.response.status, error.response.data);
                errorMessage = error.response.data.message || `Server error: ${error.response.status}`;
            } else if (error.request) {
                // Request was made but no response received
                console.error('No response:', error.request);
                errorMessage = 'No response from server';
            } else if (error.message) {
                // Something happened in setting up the request
                console.error('Request setup error:', error.message);
                errorMessage = error.message;
            } else {
                console.error('Unknown error:', error);
            }

            showToast(errorMessage, 'error');
        } finally {
            StopLoading(setisLoading);
        }
    };


    const GetproductVariants = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProductVariant`, { productUinqueID: uniqueID, app: 0 }, { withCredentials: true })
                .then((res) => {
                    if (res.data.success === 1) {
                        setisLoading(false);
                        setisDisabled(false);
                        // console.log(res.data.data);

                        // setisData(true);
                        const data_len = res.data.data.length;
                        // setTableDatacount(data_len);
                        // setisVariantData(true);
                        setgetVariant(res.data.data);

                        // toastifn(1, res.data.message);

                        // setCategories(res.data.data);
                        // setFilteredCategories(res.data.data);
                        // setSheetdata(res.data.data);
                    }
                    else {
                        // setisData(false);
                        // toastifn(0, res.data.message);
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        console.error('Server responded with a status:', err.response.status);
                        console.error('Response data:', err.response.data);
                    } else if (err.request) {
                        console.error('No response received:', err.request);
                    } else {
                        console.error('Error setting up request:', err.message);
                    }
                    // toastifn(0, "Something went wrong! Please try again later.");
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast(" later 4 ", 'error');
        }
    }

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const [selectedColumns, setSelectedColumns] = useState(['id', 'product_variant_image', 'product_variant',]);
    const allColumns = ['id', 'product_variant_image', 'selling_unit', 'selling_unit_packing_type', 'shipping_unit', 'shipping_unit_packing_type', 'product_variant', 'product_hsn_code', 'product_warrenty', 'minimum_order_quantity', 'product_id', 'product_mrp', 'product_price', 'product_link', 'product_stock'];
    const [columnWidths, setColumnWidths] = useState({
        id: 150,
        product_variant_image: 100,
        selling_unit: 50,
        selling_unit_packing_type: 50,
        shipping_unit: 50,
        shipping_unit_packing_type: 50,
        product_variant: 100,
        product_hsn_code: 50,
        product_warrenty: 50,
        minimum_order_quantity: 50,
        product_id: 50,
        product_mrp: 50,
        product_price: 50,
        product_link: 100,
        product_stock: 50,
    });
    // const tableRef = useRef(null);
    const toggleColumn = (column) => {
        setSelectedColumns((prev) =>
            prev.includes(column)
                ? prev.filter((col) => col !== column)
                : [...prev, column]
        );
    };
    const handleMouseDown = (col) => (e) => {
        e.preventDefault();
        const startX = e.clientX;

        const handleMouseMove = (moveEvent) => {
            const newWidth = Math.max(columnWidths[col] + (moveEvent.clientX - startX), 50); // Minimum width
            setColumnWidths((prev) => ({ ...prev, [col]: newWidth }));
        };

        const handleMouseUp = () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
    };









    // product Photos 
    // Handle image upload
    const handleProductPhotoSubmit = async (e) => {
        e.preventDefault();
        StartLoading(setisLoading);

        if (acceptedFiles.length === 0) {
            StopLoading(setisLoading);
            showToast("Please select images to upload ", 'error');
            setPhotoError("Please select images to upload.");
            return;
        }

        setIsUploading(true);
        setUploadingStatus(`Uploading ${acceptedFiles.length} image(s)...`);

        const formData = new FormData();
        formData.append('unique_key', uniqueID);
        formData.append('app', 0);
        acceptedFiles.forEach((file) => {
            formData.append('productImage', file);
        });

        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/UploadProductImage`, formData, { withCredentials: true }).then((response) => {
                // console.log(response.data);
                StopLoading(setisLoading);
                if (response.data.success === 1) {
                    showToast(response.data.message, 'success');
                    // setUploadedImages(response.data.files); // Store uploaded file paths
                    // setUploadingStatus(`${response.data.files.length} image(s) uploaded successfully.`);
                    setIsUploading(false);
                    setDisabledStatus(prevState => ({
                        ...prevState, productDetails: false, productVariant: false, productPhoto: false, productDocument: false, productOffers: false
                    }));
                }
                else {
                    StopLoading(setisLoading);
                    showToast(response.data.message, 'error');
                }
            })
        } catch (err) {
            console.error("Error uploading files:", err);
            setPhotoError("Failed to upload images.");
            setUploadingStatus("");
            setIsUploading(false);
            StopLoading(setisLoading);
        }
        // console.log({ isDisabled: isDisabled });
    };

    // Remove image from preview list
    const handleRemovePreview = (fileToRemove) => {
        setFilePreviews((prev) => prev.filter(({ file }) => file !== fileToRemove));
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileType = file.name.split('.').pop().toLowerCase();
            setCurrentFile({
                file,
                name: file.name,
                type: fileType
            });
        }
    };
    // const handleAddDocument = async () => {
    //     if (!fileTitle.trim()) {
    //         showToast('Document title should not be empty!', 'error');
    //         return;
    //     }

    //     if (!currentFile) {
    //         showToast('Please select a file first!', 'error');
    //         return;
    //     }


    //     // Add to pending files list (will be uploaded on submit)
    //     setUploadedFiles(prev => [
    //         ...prev,
    //         {
    //             title: fileTitle,
    //             name: currentFile.name,
    //             type: currentFile.type,
    //             file: currentFile.file,
    //             status: 'pending' // 'pending', 'uploaded', 'failed'
    //         }
    //     ]);
    //     const formData = new FormData();
    //     formData.append("product_UID", uniqueID);
    //     formData.append("document_type", file.type);
    //     formData.append('document', file.file);
    //     formData.append('document_title', file.title);

    //     const res = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddProductdocs`,
    //         formData,
    //         {
    //             withCredentials: true,
    //             headers: {
    //                 'Content-Type': 'multipart/form-data'
    //             }
    //         }
    //     );

    //     return {
    //         ...file,
    //         status: 'uploaded',
    //         data: res.data.data
    //     };
    //     // Reset current file and title
    //     setCurrentFile(null);
    //     setFileTitle('');
    //     if (fileInputRef.current) {
    //         fileInputRef.current.value = '';
    //     }

    //     showToast('Document added for upload! Click Submit to upload all.', 'success');
    // };


    const handleAddDocument = async () => {
        if (!fileTitle.trim()) {
            showToast('Document title should not be empty!', 'error');
            return;
        }

        if (!currentFile) {
            showToast('Please select a file first!', 'error');
            return;
        }

        // Create a new file object with pending status
        const newFile = {
            title: fileTitle,
            name: currentFile.name,
            type: currentFile.type,
            file: currentFile,
            status: 'pending' // 'pending', 'uploading', 'uploaded', 'failed'
        };

        // Add to files list with 'uploading' status
        setUploadedFiles(prev => [
            ...prev,
            { ...newFile, status: 'uploading' }
        ]);

        try {
            const formData = new FormData();
            formData.append("product_UID", uniqueID);
            formData.append("document_type", newFile.type);
            formData.append('document', newFile.file);
            formData.append('document_title', newFile.title);
            formData.append('app', 0);

            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/AddProductdocs`,
                formData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            StopLoading(setisLoading);
            //   console.log('Response data:', response.data);
            if (!response || !response.data) {
                throw new Error('Invalid server response structure');
            }

            if (response.data && response.data.success === 1) {

                // console.log(response);
                // Update the file status to 'uploaded'
                setUploadedFiles(prev => prev.map(file =>
                    file.name === newFile.name ? {
                        ...file,
                        status: 'uploaded',
                        data: response.data.data
                    } : file
                ));

                showToast('Document uploaded successfully!', 'success');

                setDisabledStatus(prevState => ({
                    ...prevState, productOffers: false,
                }));
            } else {
                throw new Error(response.data?.message || 'Unknown server response');
            }


        } catch (err) {
            console.error('Upload error:', err);
            // Update the file status to 'failed'
            setUploadedFiles(prev => prev.map(file =>
                file.name === newFile.name ? { ...file, status: 'failed' } : file
            ));
            showToast('Failed to upload document', 'error');
        } finally {
            // Reset current file and title
            setCurrentFile(null);
            setFileTitle('');
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };
    const handleUpload = async () => {
        if (!fileTitle.trim()) {
            showToast('Document title should not be empty!', 'error');
            return;
        }

        if (!currentFile) {
            showToast('Please select a file first!', 'error');
            return;
        }

        if (currentFile.size > 5 * 1024 * 1024) {
            const sizeInMB = (currentFile.size / (1024 * 1024)).toFixed(2);
            showToast(`Selected file is ${sizeInMB} MB. Max allowed size is 5 MB!`, 'error');
            return;
        }

        const formData = new FormData();
        formData.append("product_UID", uniqueID);
        formData.append("document_type", currentFile.type);
        formData.append('document', currentFile.file);
        formData.append('document_title', fileTitle);
        formData.append('app', 0);

        try {
            const res = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/AddProductdocs`,
                formData,
                { withCredentials: true }
            );

            // Add to uploaded files list
            setUploadedFiles(prev => [
                ...prev,
                {
                    title: fileTitle,
                    name: currentFile.name,
                    type: currentFile.type,
                    data: res.data.data // assuming the response contains some file data
                }
            ]);

            // Reset current file and title
            setCurrentFile(null);
            setFileTitle('');
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

            showToast('Document uploaded successfully!', 'success');
        } catch (err) {
            console.error('Upload error:', err);
            showToast('Failed to upload document, please try again later', 'error');
        }
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
        // You might also want to call an API to delete the file from the server
    };

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // const handleDocsSubmit = async () => {
    //     if (uploadedFiles.length === 0) {
    //         showToast('No documents to upload!', 'error');
    //         return;
    //     }
    //     console.log({ uploadedFiles: uploadedFiles })
    //     try {
    //         // Upload all pending files
    //         const uploadPromises = uploadedFiles.map(async (file, index) => {
    //             if (file.status === 'pending') {
    //                 const formData = new FormData();
    //                 formData.append("product_UID", uniqueID);
    //                 formData.append("document_type", file.type);
    //                 formData.append('document', file.file);
    //                 formData.append('document_title', file.title);

    //                 const res = await axiosJWT.post(
    //                     `${process.env.REACT_APP_API_URL}/api/AddProductdocs`,
    //                     formData,
    //                     {
    //                         withCredentials: true,
    //                         headers: {
    //                             'Content-Type': 'multipart/form-data'
    //                         }
    //                     }
    //                 );

    //                 return {
    //                     ...file,
    //                     status: 'uploaded',
    //                     data: res.data.data
    //                 };
    //             }
    //             return file;
    //         });

    //         const updatedFiles = await Promise.all(uploadPromises);
    //         setUploadedFiles(updatedFiles);
    //         showToast('All documents uploaded successfully!', 'success');
    //     } catch (err) {
    //         console.error('Upload error:', err);
    //         showToast('Failed to upload some documents', 'error');
    //     }
    // };



    // Product Offers 
    const handleDocsSubmit = async () => {
        if (uploadedFiles.length === 0) {
            showToast('No documents to upload!', 'error');
            return;
        }
        // console.log({ uploadedFiles: uploadedFiles });
        // try {
        //     const updatedFiles = [];
        //     for (const file of uploadedFiles) {
        //         if (file.status === 'pending') {
        //             const formData = new FormData();
        //             formData.append("product_UID", uniqueID);
        //             formData.append("document_type", file.type);
        //             formData.append('document', file.file);
        //             formData.append('document_title', file.title);

        //             const res = await axiosJWT.post(
        //                 `${process.env.REACT_APP_API_URL}/api/AddProductdocs`,
        //                 formData,
        //                 {
        //                     withCredentials: true,
        //                     headers: {
        //                         'Content-Type': 'multipart/form-data'
        //                     }
        //                 }
        //             );

        //             updatedFiles.push({
        //                 ...file,
        //                 status: 'uploaded',
        //                 data: res.data.data
        //             });
        //         } else {
        //             updatedFiles.push(file);
        //         }
        //     }
        //     setUploadedFiles(updatedFiles);
        //     showToast('All documents uploaded successfully!', 'success');
        // } catch (err) {
        //     console.error('Upload error:', err);
        //     showToast('Failed to upload some documents', 'error');
        // }
    };


    const handleoffermodalshow = () => {
        setOffermodalshow(true);
    }
    const handleoffermodalhide = () => {
        setOffermodalshow(false);
    }
    const handleofferssubmit = async (e) => {
        StartLoading(setisLoading);
        e.preventDefault();

        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Addproductoffers`, { data: { uniqueID, offerdata, app: 0 } }, { withCredentials: true })
                .then((res) => {
                    var result = JSON.parse(JSON.stringify(res));
                    // console.log({ result: result });
                    if (result.data.success === 1) {

                        handleoffermodalhide();
                        StopLoading(setisLoading);
                        // setOffers(result.data.data);
                        setOffers(Array.isArray(result.data.data) ? result.data.data : [result.data.data]);
                        setDisabledStatus(prevState => ({
                            ...prevState, productDetails: false, productVariant: false, productPhoto: false,
                            productDocument: false, productShortDescription: false,
                            productLongDescription: false,
                        }));
                        showToast(result.data.message, 'success');
                    }
                    else {
                        StopLoading(setisLoading);
                        showToast(result.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to Add offer, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Add offer, please try again later ", 'error');
        }

    }
    const handleofferChange = (e, i) => {
        const { name, value } = e.target
        const onchangeVal = [...offerdata]
        onchangeVal[i][name] = value
        setOfferData(onchangeVal);
    }

    const handleofferDelete = (i) => {
        const deleteVal = [...offerdata]
        deleteVal.splice(i, 1)
        setOfferData(deleteVal)
    }
    const handleofferClick = () => {
        setOfferData([...offerdata, { offers: "" }])
    }
    const offerscolumns = [
        {
            name: "Offer Details",
            width: '300px',
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            selector: (row) => row.product_offers,
        },
    ]



    //   Long Description 
    const handlelongdescChange = (e, editor) => {
        const longDescriptiondata = editor.getData();
        setLongDescription(longDescriptiondata);
    }
    const handlelongDescriptionsSubmit = async (e) => {
        e.preventDefault();
        const long_desc_data = longdesc;
        StartLoading(setisLoading);

        await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddProductLongDescriptions`, { uniqueID, long_desc_data, app: 0 }, { withCredentials: true })
            .then((res) => {
                var result = JSON.parse(JSON.stringify(res));
                if (result.data.success === 1) {

                    // redirectviewproduct();
                }
                else {

                    StopLoading(setisLoading);
                    showToast("Failed to Add short description, please try again later ", 'error');
                }
            })
            .catch((err) => {
                StopLoading(setisLoading);
                showToast("Failed to Add short description, please try again later ", 'error');
            });
        // }
    }


    const handlefinalProductSubmit = async (e) => {
        e.preventDefault();
        finalProductSubmit();
        // StartLoading(setisLoading);
        // const validationErrors = validateAndSetErrors(values);
        // console.log({ validationErrors: validationErrors });
        // if (Object.keys(validationErrors).length === 0) {
        //     StopLoading(setisLoading)
        //     clearAllErrors();
        //     finalProductSubmit();
        // }
    }


const showValidationToast = (disabledStatus) => {
  const missingFields = Object.entries(disabledStatus)
    .filter(([key, value]) => value === true && key !== "productOffers")
    .map(([key]) => key);

  if (missingFields.length > 0) {
    toast.error(`Required field missing: ${missingFields.join(", ")}` , {theme:"colored"});
    return true;
  }

  return false;
};

    const finalProductSubmit = async () => {


if (showValidationToast(disabledStatus)) {
    return; // stop submit
  }
        StartLoading(setisLoading);

        const product_unique_id = uniqueID;
        const is_visible = isVariantVisible;
        const is_active = isVariantActive;

        if (product_unique_id !== '') {
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddProductConfirm`, { product_unique_id,is_visible , is_active  , app: 0 }, { withCredentials: true })
                    .then((response) => {
                        StopLoading(setisLoading);
                        if (response.data.success === 1) {
                            showToast(response.data.message, 'success');
                            setTimeout(() => {
                                handlenavigateProducts();
                            }, 1000);
                        }
                        else {
                            StopLoading(setisLoading)
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        if (err.status === 401) {
                            alert('Logout');
                        }
                        else {
                            showToast(err.data.message, 'error');
                        }
                    });
            } catch (err) {
                StopLoading(setisLoading);
                showToast(" later 5 ", 'error');
            }
        }
        else {
            StopLoading(setisLoading);
            showToast("Please Fill All Required Fileds ", 'error');
        }
    }
    // console.log({ selectedCategorie: selectedCategories });

    const handleToggleVariantVisible = () => {
        setIsVariantVisible(!isVariantVisible);
        // console.log("Variant Visible:", !isVariantVisible);
    };

    const handleToggleVariantActive = () => {
        setIsVariantActive(!isVariantActive);
        // console.log("Variant Active:", !isVariantActive);
    };



    return {
        users, userPlan, Remainuser, subUser, badges, handleProductDetailsSubmit, values, handleDetailsInputChange, handleCategoryChange, categories, selectedCategories, categoryData, disabledStatus, variants, variantvalues, variationmodalShow, handlevariationmodalshow, handlevariationmodalhide, userAttributesarray, handleSellingUnit, handleVariantInput, packingtype, setPackingtype, packingtypeSelected, setPackingtypeSelected, measurementinputValue, setMeasurementInputValue, packingtypedata, measurementdata, packingtypeinputValue, handlepackingtype, shippingpackingtype, setShippingPackingtype, shippingpackingtypeSelected, setShippingPackingtypeSelected, shippingmeasurementinputValue, setShippingMeasurementInputValue, shippingSelected, handleshippingpackingtype, handlevariantSave, toggleDropdown, isDropdownOpen, selectedColumns, columnWidths, allColumns, toggleColumn, handleMouseDown, getVariant, uniqueID, handleoffermodalshow, handleoffermodalhide, offermodalshow, handleofferssubmit, offerdata, handleofferChange, handleofferDelete, handleofferClick, offerscolumns, handleshortdescChange, shortdesc, filePreviews, uploadingStatus, photoerror, isUploading, getInputProps, getRootProps, handleRemovePreview, handleProductPhotoSubmit, offers, handlelongdescChange, handlelongDescriptionsSubmit, longdesc, setLongDescription, handlefinalProductSubmit, selectedBadge, setSelectedBadge, handleBadgeChange, warehouse, setWarehouse, selectedwarehouse, handlewarehouseChange,
        handleProductCategrySubmit, handleVariantPhotoUpload, fileTitle, setFileTitle, currentFile, setCurrentFile, uploadedFiles, setUploadedFiles, fileInputRef, handleFileChange, handleUpload, removeFile, triggerFileInput, handleAddDocument, handleDocsSubmit, isVariantVisible, setIsVariantVisible, isVariantActive, setIsVariantActive,
        handleToggleVariantVisible, handleToggleVariantActive, isLoading , variantError
    }
}

export default MidAddProducts